import React from 'react';
import { Modal, Card, Tooltip, Tag } from 'antd';
import { app } from 'xadmin';
import { C } from 'xadmin-ui';
import PointTable from '../components/PointTable';

const PointTableComponent = (props) => {
  const { input, outputParams, model, nodeFilters } = props
  const [ visible, setVisible ] = React.useState(false)
  return (
    <>
      <Card onClick={() => { setVisible(true) }} bodyStyle={{ width: '100%', borderRadius: '5px', padding: 5, minHeight: 30 }}>
        {outputParams ? outputParams?.map(item => (
          <span key={item.ref_id}><Tooltip key={item.id} title={'所属资产 ' + (item.node && item.node.name || '')}>
            <Tag>{item.name}</Tag>
          </Tooltip>
          </span>
        )) : '点击选择数据点'}
      </Card>
      <Modal title="数据点选择" visible={visible} width={1200} onCancel={() => { setVisible(false) }} onOk={() => { setVisible(false) }}>
        <PointTable input={{...input, value: outputParams}} model={model} nodeFilters={nodeFilters}></PointTable>
      </Modal>
    </>
  )
}

const PointTableWidget = {
  title: '数据点选择器',
  category: '业务选择器',
  icon: require('../icon/数据点选择器.svg'),
  component: PointTableComponent,
  paramSchema: {
    type: 'object',
    properties: {
      model: {
        type: 'array',
        title: '模型选择',
        items: {
          type: 'object',
          name: 'model',
          properties: {
            id: { type: 'string' },
            name: { type: 'string' }
          }
        },
        fieldType: 'modelselect_multip',
      },
      nodeFilters: {
        title: '内置查询',
        type: 'array',
        unbind: true,
        // properties: {},
        items: {},
        field: { component: ({ input }) => {
          const viewSchema = app.get('models').Node
          viewSchema.properties = _.omit(viewSchema.properties, ['model', 'parent'])
          return <C is="DashboardModalButton" align="left" offset={100} title="内置查询">
            <C is='QueryEditor'
              schema={_.pick(viewSchema, ['type', 'properties'])}
              input={input}
            />
          </C>
        } }
      },
    }
  },
  fieldWidget: true,
  // initParam: { placeholder: '请选择资产' },
  initLayout: { width: 160, height: 40 }
}

export default PointTableWidget
